import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { PHead } from "../components/global/PHead/PHead";
import { OurPoliciesScreen } from "../components/screens/S-OurPolicies/OurPoliciesScreen";
import { globalTranslationFiles } from "../utils/help/localization/localization";
import { getRestaurantStaticProps } from "../utils/help/staticProps/restaurantStaticProps";

function OurPolicies() {
  return (
    <>
      <PHead title="Our Policies" />
      <OurPoliciesScreen />
    </>
  );
}

export async function getStaticProps(context: any) {
  // Every page needs the restaurant config in redux: _app hydrates from
  // pageProps.restaurantInfo, and the shared layout reads it. Before #4204
  // useRestaurantData fetched it in the browser on EVERY page, so a page
  // that never fetched it still had it. #4204
  const { restaurantInfo, socialMediaInfo } = await getRestaurantStaticProps();

  return {
    props: {
      restaurantInfo,
      socialMediaInfo,
      ...(await serverSideTranslations(context.locale || "en", [
        ...globalTranslationFiles,
        "common",
        "sidemenu",
        "our-policies",
      ])),
    },
  };
}

OurPolicies.displayName = "OurPolicies";

export default OurPolicies;
